import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { H4 } from '#app/components/typography/h4.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'H4',
}

const component: componentProps = {
	name: 'H4',
	shortName: 'H4',
	fileName: 'h4',
	category: 'typography',
	description: ['H4 heading component.'],
	features: ['Drop-in replacement for the native <h4> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<H4>This is an h4 heading</H4>`,
	styling: `.h4 {
	@apply text-muted-900 mt-fluid-14 mb-fluid-5 text-fluid-xl max-w-prose font-sans font-bold capitalize;
	/* Typographical elements after h4 */
	& + .p {
		@apply mt-0;
	}
}`,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<H4>This is an h4 heading</H4>
			<Features features={features} />
			<Parts parts={parts} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
